export const buildCityName = (prefectureName: string, cityName: string) => {
  return `${prefectureName} ${cityName}`
}
